import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContactDetailsFormData } from "src/components/feature/Onboarding/ContactDetails";
import { resetFormAction } from "src/redux/createActions/resetForms";

interface InitialState {
  formData: ContactDetailsFormData;
}

const initialState: InitialState = {
  formData: {
    fullName: "",
    email: "",
    phone: {
      countryCode: "+91",
      number: "",
    },
    mobilePhone: {
      countryCode: "+91",
      number: "",
    },
    name: "",
    designation: "",
    selfDeclaration: false,
  },
};

const contactDetailsSlice = createSlice({
  name: "contactDetails",
  initialState,
  reducers: {
    updateContactDetailsForm: (
      state,
      action: PayloadAction<ContactDetailsFormData>
    ) => {
      state.formData = {
        ...state.formData,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetFormAction, (state, _action) => {
      state.formData = initialState.formData;
    });
  },
});

export const { updateContactDetailsForm } = contactDetailsSlice.actions;

export default contactDetailsSlice.reducer;
